import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { fetchLayoutsOffers } from '../services';
import { NewbuildingLayoutsContext } from '../shared/context';
export var useLayoutModal = function useLayoutModal(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    layouts = _ref.layouts,
    isLayoutModalDisabled = _ref.isLayoutModalDisabled;
  var _React$useContext = React.useContext(NewbuildingLayoutsContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    layoutId = _React$useState2[0],
    setLayoutId = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpened = _React$useState4[0],
    setIsOpened = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    loading = _React$useState6[0],
    setIsLoading = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    layoutOffers = _React$useState8[0],
    setLayoutOffers = _React$useState8[1];
  var layoutImageUrl = React.useMemo(function () {
    var _layouts$find;
    return (_layouts$find = layouts.find(function (layout) {
      return layout.layoutKey === layoutId;
    })) === null || _layouts$find === void 0 ? void 0 : _layouts$find.image;
  }, [layoutId, layouts]);
  var onLayoutCardClick = function onLayoutCardClick(layoutKey) {
    if (isLayoutModalDisabled) {
      return;
    }
    setIsLoading(true);
    setIsOpened(true);
    setLayoutOffers(null);
    setLayoutId(layoutKey);
    fetchLayoutsOffers({
      httpApi: httpApi,
      logger: logger,
      params: {
        newbuildingId: newbuildingId,
        houseId: houseId,
        layoutKey: layoutKey
      }
    }).then(function (response) {
      setLayoutOffers(response);
    }).finally(function () {
      setIsLoading(false);
    });
  };
  var onClose = function onClose() {
    return setIsOpened(false);
  };
  var onReset = function onReset() {
    setIsLoading(true);
    fetchLayoutsOffers({
      httpApi: httpApi,
      logger: logger,
      params: {
        newbuildingId: newbuildingId,
        houseId: houseId,
        layoutKey: layoutId
      }
    }).then(function (response) {
      setLayoutOffers(response);
    }).finally(function () {
      setIsLoading(false);
    });
  };
  return {
    isOpened: isOpened,
    loading: loading,
    onLayoutCardClick: onLayoutCardClick,
    onClose: onClose,
    onReset: onReset,
    layoutImageUrl: layoutImageUrl,
    layoutOffers: layoutOffers
  };
};